<div class="login">
  <div class="login-form">
    <div class="page-header">
      <div class="logo"></div>
    </div>

    <form [formGroup]="form">
      <hr>
        <h4 class="h4" translate>Reset password</h4>
        <p class="text-muted mb-4" translate>Enter a new password below so you can login to your account.</p>
        <div class="form-group">
          <label for="password">
            <span translate>New password</span>
            <span class="ml-1 label-required">*</span>
          </label>
          <div class="input-group input-group-pw">
            <input [ngClass]="{ 'is-invalid': form.controls.password.errors }"
              [type]="isPasswordVisible ? 'text': 'password'"
              class="form-control"
              formControlName="password" id="password" name="password">
              <span (click)="onShowPasswordChange()"
                [ngClass]="{'fa-eye-slash':!isPasswordVisible,
                                          'fa-eye': isPasswordVisible}"
                class="far btn-show-hide-pw">

              </span>
            </div>

            @if (form.controls.password.errors) {
              <div class="invalid-feedback">
                @if (form.controls.password.errors.required) {
                  <span translate>Password required</span>
                }
                @if (form.controls.password.errors.pattern) {
                  <span
                  translate>The password must contain both letters and digits and must be at least 8 characters long</span>
                }
              </div>
            }
          </div>

          <div class="form-group">
            <label for="confirmPassword">
              <span translate>Confirm new password</span>
              <span class="ml-1 label-required">*</span>
            </label>
            <div class="input-group input-group-pw">
              <input [ngClass]="{ 'is-invalid': form.controls.confirmPassword.errors }"
                [type]="isPasswordVisible ? 'text': 'password'"
                class="form-control"
                formControlName="confirmPassword" id="confirmPassword" name="confirmPassword">
                <span (click)="onShowPasswordChange()"
                [ngClass]="{'fa-eye-slash':!isPasswordVisible,
                            'fa-eye': isPasswordVisible}"
                  class="far btn-show-hide-pw">
                </span>
              </div>

              @if (form.controls.confirmPassword.errors) {
                <div class="invalid-feedback">
                  @if (form.controls.confirmPassword.errors.required) {
                    <span translate>Password required</span>
                  }
                  @if (form.controls.confirmPassword.errors.equal) {
                    <span translate>Passwords must be identical</span>
                  }
                </div>
              }
            </div>
            <button (click)="handleResetPassword()"
              [disabled]="form.controls.confirmPassword.errors || form.controls.password.errors"
              class="btn btn-primary btn-md btn-block">
              <span translate>Reset Password</span>
            </button>

            <button (click)="redirectToLoginPage()"
              class="btn btn-link text-white btn-md btn-block btn-reset-pw"
              type="button">
              <span class="fa-solid fa-chevron-left"></span>
              <span translate>Go back to login</span>
            </button>
          </form>
        </div>
      </div>
